// extracted by mini-css-extract-plugin
export default {"second_part":"second_second_part__q9Lf6","second":"second_second__zWfuD"};